import React from "react";
import PropTypes from "prop-types";
import { svgContainer } from "../../../constants/trendGraph/buttonStyles";
import { Box } from "@mui/material";

const MinimizeIcon = ({ width = 25, height = 25, disabled = false }) => {
  const color = disabled ? "#FFFFFF" : "#D8D8D8";
  const opacity = disabled ? "0.5" : "1";

  return (
    <Box sx={svgContainer}>
      <svg
        width={width}
        height={height}
        viewBox="0 -3 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 8.125h-3.125V5M16.25 3.75l-4.375 4.375M5 11.875h3.125V15M3.75 16.25l4.375-4.375M11.875 15v-3.125H15M16.25 16.25l-4.375-4.375M8.125 5v3.125H5M3.75 3.75l4.375 4.375"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity={opacity}
        />
      </svg>
    </Box>
  );
};

MinimizeIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  disabled: PropTypes.bool,
};

export default MinimizeIcon;
